import Constants from '../config/const';
import { openPanel, closePanel } from './panel';

export const show = (index) => (dispatch) => {
  dispatch({ type: Constants.workDetails.show, index });
  dispatch(openPanel({ kind: Constants.panelKinds.details }));
};

export const hide = () => (dispatch) => {
  dispatch(closePanel({ kind: Constants.panelKinds.details }));
  dispatch({ type: Constants.workDetails.hide });
};
